class VeluxoPriceSort extends HTMLElement {
  connectedCallback(){this.querySelector('[data-sort-retry]').onclick=()=>this.sort();this.sort();}
  disconnectedCallback(){this.controller?.abort();}
  async sort(){
    this.controller?.abort();
    const controller=this.controller=new AbortController();
    const grid=this.querySelector('.product-grid');
    if(!grid){this.querySelector('[data-sort-status]').hidden=true;return;}
    const status=this.querySelector('[data-sort-status]');
    const retry=this.querySelector('[data-sort-retry]');
    this.loadingText ||= status.textContent;
    status.textContent=this.loadingText;
    status.hidden=false;retry.hidden=true;
    this.removeAttribute('data-failed');this.setAttribute('aria-busy','true');
    try{
      const cards=new Map(Array.from(grid.querySelectorAll(':scope > [data-product-id]')).map(card=>[card.dataset.productId,card]));
      for(let page=1;page<=Number(this.dataset.pages);page++){
        if(page===Number(this.dataset.page))continue;
        const url=new URL(location.href);url.searchParams.set('section_id',this.dataset.section);url.searchParams.set('page',String(page));
        const response=await fetch(url,{signal:controller.signal});
        if(!response.ok)throw Error('Page unavailable');
        const html=new DOMParser().parseFromString(await response.text(),'text/html');
        const next=html.querySelector('veluxo-price-sort');
        if(!next)throw Error('Missing collection page');
        next.querySelectorAll('.product-grid > [data-product-id]').forEach(card=>cards.set(card.dataset.productId,card));
      }
      if(controller.signal.aborted||!this.isConnected)return;
      if(cards.size!==Number(this.dataset.count))throw Error('Incomplete collection');
      const direction=this.dataset.direction==='price-descending'?-1:1;
      const sorted=Array.from(cards.values());
      if(sorted.some(card=>!Number.isFinite(Number(card.dataset.maxPrice))))throw Error('Missing price');
      sorted.sort((a,b)=>direction*(Number(a.dataset.maxPrice)-Number(b.dataset.maxPrice))||a.dataset.productId.localeCompare(b.dataset.productId));
      grid.replaceChildren(...sorted);
      this.querySelectorAll('[ref="viewMorePrevious"],[ref="viewMoreNext"],nav[aria-label*="agination"]').forEach(el=>el.remove());
      status.hidden=true;
    }catch(error){
      if(controller.signal.aborted)return;
      this.setAttribute('data-failed','');
      status.textContent=this.querySelector('[data-sort-error]').textContent;
      retry.hidden=false;
    }finally{if(!controller.signal.aborted)this.removeAttribute('aria-busy');}
  }
}
if(!customElements.get('veluxo-price-sort'))customElements.define('veluxo-price-sort',VeluxoPriceSort);
